import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { Card, S4HorseLogo, SISAppleLogo, s4Theme, sisTheme, } from "@ssf/components";
import { OpenInNew } from "mdi-material-ui";
import { useTranslation } from "react-i18next";
export const TeamParticipationCard = ({ isS4 }) => {
    const { t } = useTranslation("TeamParticipationCard");
    return (_jsxs(Card, { paperProps: {
            sx: {
                background: isS4
                    ? s4Theme.palette.primary.main
                    : sisTheme.palette.primary.main,
                color: "white",
                display: "flex",
                alignItems: "center",
                py: 1.5,
                svg: {
                    fill: "currentColor",
                    height: ({ spacing }) => spacing(3),
                },
            },
        }, children: [isS4 ? _jsx(S4HorseLogo, {}) : _jsx(SISAppleLogo, {}), _jsx(Typography, { sx: { flex: "1 0 auto", ml: 1 }, children: t(`label_${isS4 ? "s4" : "y2c"}`) }), _jsx(OpenInNew, {})] }));
};
//# sourceMappingURL=TeamParticipationCard.js.map